'use client'

import { createContext } from 'react'

interface NavContextState {
  isMobile: boolean
  setIsMobile(value: boolean): void
}

const NavContext = createContext<NavContextState>({
  isMobile: false,
  setIsMobile: () => false,
})

export default NavContext
